import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["refreshNotice"]
  static values = { refreshTarget: String }

  researchChanged(event) {
    if (event.target.getAttribute("target") !== this.refreshTargetValue) return
    event.preventDefault()
    this.refreshNoticeTarget.hidden = false
  }

  openEvidence(event) {
    const id = event.currentTarget.hash.slice(1)
    const source = document.getElementById(id)
    if (!source) return
    event.preventDefault()

    let details = source.closest("details")
    while (details) {
      details.open = true
      details = details.parentElement?.closest("details")
    }
    source.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
